/*
 * @Author: zhouwei
 * @Date: 2019-11-18 15:30:37
 * @Last Modified by: huangzq
 * @Last Modified time: 2019-11-22 17:26:07
 * @Desc: 表单提交数据列表
*/
<template>
  <div class="form-data-detail">
    <div class="title">
      <div
        class="back"
        @click="goBack"
      >
        <mk-iconfont
          icon-class="left"
          class="icon"
        ></mk-iconfont>
        <span class="txt">表单数据 - {{ title }}</span>
      </div>
      <div class="table-info">
        <span
          v-if="deptType==='dept'"
          class="first"
        >部门权限：{{ deptName }}</span>
        <span
          v-if="deptType==='owner'"
          class="first"
        >个人权限：{{ deptName }}</span>
        <!-- <span v-if="deptName === 'deptType'"></span> -->
        <span class="first">表单提交总数: {{ total }}</span>
        <span>今日提交表单：{{ todaySubmit }}</span>
      </div>
    </div>
    <div class="header">
      <div class="search-list">
        <mk-date-picker
          v-model="date"
          class="search-list-item"
          type="daterange"
          :clearable="false"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </mk-date-picker>
        <mk-cascader
          v-if="depShow"
          v-model="departe"
          class="search-list-item"
          :options="departeList"
          :props="props"
          size="small"
          placeholder="选择部门"
          width="160"
          :multiple="true"
          collapse-tags
          clearable
          @change="deptChange"
        ></mk-cascader>
        <mk-select
          v-if="memShow"
          v-model="member"
          class="search-list-item"
          placeholder="选择成员"
          multiple
          width="140"
          clearable
          @change="memberChange"
        >
          <mk-option
            v-for="(item,index) in memberList"
            :key="index"
            :label="item.name"
            :value="item._id"
          ></mk-option>
        </mk-select>
        <mk-button-biz
          icon="el-icon-search"
          class="search-btn"
          type="primary"
          @click="search"
        >
          搜索
        </mk-button-biz>
        <mk-button-biz @click="reset">
          重置
        </mk-button-biz>
      </div>
      <div class="switch">
        <span>显示已删列</span>
        <mk-switch
          v-model="showAll"
          class="switch-btn"
          @change="change"
        ></mk-switch>
      </div>
    </div>
    <!-- <div class="table"> -->
    <table-list
      ref="tableList"
      class="table"
      :date="date"
      :is-all="showAll"
      :member-list="memberList"
      :departe-list="departeList"
      :dept="metasDept"
      :member="metasMember"
      @cancel="cancelSelect"
      @select="select"
      @handle-show="handleCanShow"
      @screen="getScreenNum"
    ></table-list>
    <!-- </div> -->
    <handle-data
      :show="handleShow"
      :select-number="selectNumber"
      :screen="screenNum"
      :export-url="exportUrl"
      @cancel="handleCancel"
      @check-all="checkAll"
      @export-data="exportFormData"
    ></handle-data>
  </div>
</template>
<script>
import tableList from './components/table-list.vue'
import handleData from './components/handle-data.vue'
import { mapMutations } from 'vuex'
import { BIZAPIS } from '../../../api'
import dayjs from 'dayjs'
export default {
  components: {
    tableList,
    handleData
  },
  data () {
    return {
      title: '', // 文章标题
      props: {
        // 重定义部门选择属性名
        label: 'name',
        value: '_id',
        multiple: true
      },
      date: [], // 日期
      departe: [], // 部门
      departeList: [], // 部门列表
      member: '', // 成员
      memberList: [], // 成员列表
      handleShow: false, // 是否显示底部操作条
      selectNumber: 0, // 选中条数
      total: 0, // 总数
      todaySubmit: 0, // 今日提交数
      showAll: false, // 是否显示已删项
      selectArr: [], // 选择项
      exportUrl: '', // 导出xls地址
      depShow: false, // 显示部门选择
      memShow: false, // 显示成员选择
      initDate: [], // 初始日期
      screenNum: 0,
      metasDept: [], // 接口入参所需部门
      metasMember: [], // 接口入参所需成员
      deptType: 'all', // 权限类型
      deptName: '' // 显示名称（部门或成员）
    }
  },
  created () {
    this.title = this.$route.query.title
    let startDate = new Date(
      dayjs(new Date()).format('YYYY-MM') + '-1 00:00:00'
    )
    let nowDate = new Date()
    this.date = [startDate, nowDate]
    this.initDate = [startDate, nowDate]
    this.initDept()
    this.getDepartment()
    this.getMember()
    this.getFormBaseInfo()
    this.getPower()
  },
  methods: {
    ...mapMutations('system', {
      setFormText: 'SET_FORMTEXT'
    }),
    initDept () {
      const user = JSON.parse(window.localStorage.getItem('user'))
      this.deptType = user.roleLimits.pcDataLimits.m1_formData
      if (user.roleLimits.pcDataLimits.m1_formData === 'all') {
      } else if (user.roleLimits.pcDataLimits.m1_formData === 'dept') {
        // this.getDepartmentName(user.departmentId)
        this.getDepartment({
          state: true,
          id: user.departmentId
        })
      } else {
        if (user.name) {
          this.deptName = user.name + '的统计'
        }
      }
    },
    deptChange () {
      this.member = []
    },
    memberChange () {
      this.departe = []
    },
    getPower () {
      // 获取权限
      const user = JSON.parse(window.localStorage.getItem('user'))
      let power = user.roleLimits.pcDataLimits.m1_formData
      if (power === 'all') {
        this.depShow = true
        this.memShow = true
      } else {
        this.depShow = false
        this.memShow = false
      }
    },
    async getFormBaseInfo () {
      const res = await BIZAPIS.FormDataApi.materialFormDataCountGet({
        formId: this.$route.query.id
      })
      if (res.success) {
        this.total = res.data.TotalCount
        this.todaySubmit = res.data.TodayCount
      }
    },
    async getDepartment (state) {
      // 获取部门
      const res = await BIZAPIS.UserApi.timingPlanDepartmentAllGet()
      if (res.success) {
        let data = res.data
        data.push({
          _id: 'NA',
          name: '无部门'
        })
        this.departeList = data
        this.recursion(this.departeList)
        if (state && state.state) {
          this.getDeptName(data, state.id)
        }
      }
    },
    getDeptName (arr, id) {
      if (arr instanceof Array) {
        arr.forEach(item => {
          if (item._id === id) {
            if (item.name !== '') {
              this.deptName = item.name + '的统计'
            }
          }
          if (item.children && item.children instanceof Array) {
            this.getDeptName(item.children, id)
          }
        })
      }
    },
    async getMember () {
      // 获取所有成员
      const res = await BIZAPIS.UserApi.timingPlanAllUsersGet({})
      if (res.success) {
        this.memberList = res.data.data
        this.$refs.tableList.getFormDataList(
          dayjs(this.date[0]).format('YYYY-MM-DD HH:mm:ss'),
          dayjs(this.date[1]).format('YYYY-MM-DD') + ' 23:59:59'
        )
      }
    },
    recursion (arr) {
      // 删除children为空数组的属性值
      if (arr instanceof Array) {
        arr.forEach((item, index) => {
          if (item && item.children && item.children.length > 0) {
            this.recursion(item.children)
          } else {
            delete item.children
          }
        })
      }
    },
    reset () {
      // 重置
      this.date = this.initDate
      this.departe = []
      this.member = ''
      this.search('reset')
    },
    search (state) {
      // 搜索
      if (state) {
        this.handleShow = false
      } else {
        this.handleShow = true
      }
      this.selectArr = []
      this.selectNumber = 0
      let metas = {
        startTime: '',
        endTime: '',
        dept: '',
        userIds: ''
      }
      if (this.date instanceof Array && this.date.length === 2) {
        metas.startTime = dayjs(this.date[0]).format('YYYY-MM-DD HH:mm:ss')
        metas.endTime = dayjs(this.date[1]).format('YYYY-MM-DD') + ' 23:59:59'
      }
      if (this.departe instanceof Array && this.departe.length > 0) {
        metas.dept = this.handleArr(this.departe)
        this.metasDept = metas.dept
      } else {
        this.metasDept = []
      }
      if (this.member.length > 0) {
        metas.userIds = this.member
        this.metasMember = this.member
      } else {
        this.metasMember = []
      }
      this.$refs.tableList.initPage()
      this.$refs.tableList.getFormDataList(
        metas.startTime,
        metas.endTime,
        metas.dept,
        metas.userIds,
        'search'
      )
    },
    handleArr (arr) {
      // 处理部门多选数据
      let newArr = []
      arr.forEach((item, index) => {
        newArr.push(item[item.length - 1])
      })
      return newArr
    },
    goBack () {
      // 返回上一级
      this.$router.go(-1)
    },
    cancelSelect () {
      // 取消选择
      this.handleShow = false
    },
    select (arr) {
      this.selectArr = arr
      // 选择事件
      this.handleShow = true
      this.selectNumber = arr.length
    },
    handleCancel () {
      this.selectArr = []
      // 底部操作取消事件
      this.handleShow = false
      this.$refs.tableList.clearSelect()
    },
    async exportFormData (e) {
      // 导出表单数据
      if (e) {
        this.exportSearchFormPost()
      } else {
        this.exportFormGet()
      }
    },
    async exportFormGet () {
      // 选择导出
      if (this.selectArr.length === 0) {
        this.$message({
          type: 'error',
          message: '请选择导出的数据',
          showClose: true
        })
      } else {
        let formIds = ''
        this.selectArr.forEach((item, index) => {
          formIds += item._id + ','
        })
        formIds = formIds.substring(0, formIds.length - 1)
        const res = await BIZAPIS.ExportApi.exportFormGet({
          formId: this.$route.query.id,
          formIds: formIds
        })
        if (res.success) {
          this.util.download({
            href: res.data
          })
        }
      }
    },
    async exportSearchFormPost () {
      // 全部导出
      let metas = {
        startTime: '',
        endTime: '',
        dept: '',
        userIds: ''
      }
      if (this.date instanceof Array && this.date.length === 2) {
        metas.startTime = dayjs(this.date[0]).format('YYYY-MM-DD HH:mm:ss')
        metas.endTime = dayjs(this.date[1]).format('YYYY-MM-DD') + ' 23:59:59'
      }
      if (this.departe instanceof Array && this.departe.length > 0) {
        let arr = this.handleArr(this.departe)
        metas.dept = arr
      } else {
        delete metas['dept']
      }
      if (this.member.length > 0) {
        let arr = this.member
        metas.userIds = arr
      } else {
        delete metas['userIds']
      }
      const res = await BIZAPIS.ExportApi.exportSearchFormPost({
        formId: this.$route.query.id,
        ...metas
      })
      if (res.success) {
        this.util.download({
          href: res.data
        })
      }
    },
    checkAll (e) {
      this.handleShow = true
    },
    change () {
      this.$refs.tableList.getTitleList(this.showAll)
    },
    handleCanShow (e) {
      // 是否可以显示底部操作条
      setTimeout(() => {
        this.handleShow = e
      })
    },
    getScreenNum (e) {
      this.screenNum = e
    }
  }
}
</script>
<style lang="scss" scoped>
.form-data-detail {
  position: relative;
  height: 100%;
  min-width: 1000px;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;

  /deep/.el-date-editor--daterange.el-input__inner {
    width: 260px;
    height: 32px;
  }

  /deep/ .el-range-separator {
    line-height: 24px;
  }

  /deep/ .el-range__icon {
    line-height: 24px;
  }

  /deep/ .el-range__close-icon {
    line-height: 24px;
  }

  /deep/ .el-icon-circle-close {
    line-height: 24px;
  }

  .title {
    height: 60px;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 -1px 0 0 rgba(232, 232, 232, 1) inset;

    .back {
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;

      .icon {
        color: #262626;
        font-weight: 500;
        font-size: 18px;
        margin-left: 20px;
      }

      .txt {
        font-size: 16px;
        margin-left: 10px;
        font-weight: 500;
      }
    }

    .table-info {
      font-size: 13px;
      color: #595959;
      margin-right: 20px;

      .first {
        margin-right: 24px;
      }
    }
  }

  .header {
    width: calc(100% - 40px);
    margin: 0 auto;
    padding: 10px 0;
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;
    align-items: center;

    .search-list {
      display: flex;
      align-items: center;

      .search-list-item {
        margin-right: 10px;
      }

      .search-btn {
        margin-left: 10px;
      }
    }

    .switch {
      float: right;
      align-self: center;
      font-size: 14px;

      span {
        font-size: 14px;
        color: #595959;
      }

      .switch-btn {
        margin-left: 10px;
      }
    }
  }

  .table {
    width: calc(100% - 40px);
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
  }
}
</style>
